import DateService, { FMT } from "./DateService";
/**
 * Agrupa las guardias por ID_MEDIO y ordena cada grupo por FECHA_ENTRADA.
 *
 * El indice existe para que resolver la guardia de un medio en una fecha no
 * recorra la lista completa de guardias del cuadrante: se listan recursos fila
 * a fila y ese recorrido se repetiria por cada uno.
 */
export function buildMedioPersonalByMedio(medioPersonal) {
    const map = {};
    for (const mp of medioPersonal) {
        if (!map[mp.ID_MEDIO])
            map[mp.ID_MEDIO] = [];
        map[mp.ID_MEDIO].push(mp);
    }
    for (const id in map) {
        map[id].sort((a, b) => DateService.toDayjs(a.FECHA_ENTRADA, FMT.dbTimestamp).diff(DateService.toDayjs(b.FECHA_ENTRADA, FMT.dbTimestamp)));
    }
    return map;
}
